import {
  Button,
  Modal,
  Form,
  Input,
  message,
} from "antd";
import API from "../../../../services/api-request";

const AddPrivilege = (props) => {
  const [addForm] = Form.useForm();

  const onFinish = async (values) => {
    const { name } = values;

    const dataForm = {
      name
    };

    await API.Post("privilege/create", dataForm)
      .then(() => {
        message.success("Privilege has been added");
        props.onGetPrivileges();
        addForm.resetFields();
        props.onShowAdd(false);
      })
      .catch((err) => {
        console.log(err)
        message.info(
          `${err?.response?.data?.error}`
        );
      });
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const handleCancel = () => {
    props.onShowAdd(false);
    addForm.resetFields();
  };

  return (
    <>
      <Modal
        title="Add Privilege"
        open={props.showAdd}
        onCancel={handleCancel}
        footer={[
          <Button key="back" type="default" onClick={handleCancel}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" onClick={() => addForm.submit()}>
            Submit
          </Button>,
        ]}
      >
        <Form
          form={addForm}
          name="Add Form"
          style={{
            margin: "0 auto",
          }}
          layout="vertical"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <Form.Item
            label="Name"
            name="name"
            rules={[{ required: true, message: "Please input name!" }]}
          >
            <Input />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default AddPrivilege;
